import React from 'react';
import { useUIStore } from '../../store';
import { useUserStore } from '../../store';

// TODO(human): 简化版本 - 专注于Calculator功能，移除营销内容

export const HeroSection: React.FC = () => {
  return (
    <div className="bg-white dark:bg-slate-900 min-h-[400px] flex items-center">
      <div className="container mx-auto px-6 py-12">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            🔥 UPDATED - Sleep Calculator
          </h1>
          <p className="text-lg md:text-xl text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Calculate optimal sleep and wake times based on sleep cycles
          </p>
        </div>
      </div>
    </div>
  );
};

console.log('✅ HeroSection loaded successfully');